import { Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Header from './Header'
import Footer from './Footer'
import Loader from '../ui/Loader'
import BackToTop from '../ui/BackToTop'
import { useDataBackground } from '../../hooks'

const Layout = () => {
  const [loading, setLoading] = useState(true)

  // Apply data-background attributes (replaces jQuery functionality)
  useDataBackground()

  useEffect(() => {
    // Simulate page load
    const timer = setTimeout(() => {
      setLoading(false)
    }, 400)

    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      {loading && <Loader />}
      <BackToTop />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  )
}

export default Layout

